<div class="container py-3">
  <h2 class="mb-3">Dashboard</h2>


        <!-- NTRIP Connections Display Area (moved to top per request) -->
        <div class="subsection mt-2">
          <div class="d-flex justify-content-between align-items-center mb-2 subheader">
            <h4 class="m-0 subsection-title">My NTRIP Connections - Live</h4>
          </div>
          <!-- Loading State -->
          <div *ngIf="loadingConnections" class="loading-state">
            <p>Loading connections...</p>
          </div>
          <!-- No Connections State -->
          <div *ngIf="!loadingConnections && userNtripConnections.length === 0" class="no-connections">
            <p>No active NTRIP connections found.</p>
          </div>
          <!-- Single table header; grouped body rows per MountPoint with collapsible group row -->
          <div *ngIf="!loadingConnections && processedGroups.length > 0" class="connections-table table-responsive border rounded">
            <table class="table table-sm table-hover align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th>MountPoint</th>
                  <th>Type</th>
                  <th>Agent</th>
                  <th>IP Address</th>
                  <th>User</th>
                  <th>Connected For</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let g of processedGroups">
                  <tr class="group-row" (click)="toggleMpGroup(g.mpDisplay)">
                    <td class="mp-group-name"><span class="mp-value">{{ g.mpDisplay }}</span></td>
                    <td colspan="5" class="text-end small text-muted">Base: {{ g.countBase }} · Rovers: {{ g.countRovers }}
                      <span class="material-icons ms-2" style="font-size:18px; vertical-align: middle;">{{ isGroupExpanded(g.mpDisplay) ? 'expand_more' : 'chevron_right' }}</span>
                    </td>
                  </tr>
                  <tr *ngFor="let r of g.rows" [hidden]="!isGroupExpanded(g.mpDisplay)">
                    <td></td>
                    <td>{{ r.displayType }}</td>
                    <td>{{ r.agent }}</td>
                    <td>{{ r.ip }}</td>
                    <td>{{ r.user }}</td>
                    <td>{{ r.connectedFor }}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Mountpoint pager + selector row (PPK Downloader style) placed between the two subsections -->
        <!-- Move PPK-like pager/selector into the new subsection below -->
        <!-- removed from here -->
        

        <!-- spacing between top subsection and settings subsection -->
        <div class="row"><div class="col-12"><br></div></div>
        <div class="row"><div class="col-12"><br></div></div>
        <!-- New container subsection that wraps the rest components (excluding My NTRIP Connections - Live) -->
        <div class="subsection mt-2">
          <div class="d-flex justify-content-between align-items-center mb-2 subheader">
            <h4 class="m-0 subsection-title">Settings You Need for Your RTK Base(s) and Rover(s)</h4>
          </div>
          <!-- Insert pager/selector/top title at the top area inside this container -->
          <div class="d-flex justify-content-between align-items-center mt-1">
            <div class="d-flex align-items-center">
              <div><strong>MountPoint:</strong> {{ currentPage }} / {{ totalPages || 1 }}</div>
            </div>
            <div class="btn-toolbar" role="toolbar" aria-label="pagination">
              <div class="btn-group me-2" role="group" aria-label="first-prev">
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goFirst()" [disabled]="currentPage === 1">« First</button>
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goPrev()" [disabled]="currentPage === 1">‹ Prev</button>
              </div>
              <div class="btn-group me-2" role="group" aria-label="pages">
                <button *ngFor="let p of pageWindow" type="button"
                        class="btn btn-sm"
                        [ngClass]="{'btn-primary': p === currentPage, 'btn-outline-secondary': p !== currentPage}"
                        (click)="goToPage(p)">{{ p }}</button>
              </div>
              <div class="btn-group" role="group" aria-label="next-last">
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goNext()" [disabled]="currentPage === totalPages">Next ›</button>
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goLast()" [disabled]="currentPage === totalPages">Last »</button>
              </div>
            </div>
          </div>
          <div class="col-12 mb-2" *ngIf="currentMountPoint as curMp">
            <div class="d-flex align-items-center">
              <span class="me-2 small text-muted">Select a MountPoint:</span>
              <span class="mp-select-wrapper" style="min-width: 280px;">
                <select class="form-select form-select-sm mp-select"
                        [ngModel]="currentMountPoint.stMountPoint || ''"
                        (ngModelChange)="selectFromDropdownName($event)">
                  <option value=""></option>
                  <option *ngFor="let mp of sortedMountPoints" [value]="mp.stMountPoint">{{ mp.stMountPoint }}</option>
                </select>
              </span>
              <span class="ms-3" [title]="isMountpointActive(curMp.stMountPoint) ? 'Online' : 'Offline'">
                (
                <span [ngStyle]="{ display: 'inline-block', width: '10px', height: '10px', 'border-radius': '50%', 'background-color': isMountpointActive(curMp.stMountPoint) ? '#22c55e' : '#9ca3af' }"></span>
                <span class="ms-1">{{ isMountpointActive(curMp.stMountPoint) ? 'Online' : 'Offline' }}</span>
                )
              </span>
            </div>
          </div>
          <div class="row g-3 align-items-start mb-2 mt-2">
            <div class="col-12 col-md-7">
              <div class="alert alert-info py-2 px-3 h-100 dashboard-message">
                Below are the information you needed to connect our NTRIP Caster Mountpoint. To pass correction data between your base and rover, make sure connect them to the same mountpoint.
              </div>
              <!-- removed legacy selector subsection -->

              <!-- NTRIP Settings for RTK Base (stacked) -->
              <div class="subsection mt-2 ms-4">
                <div class="d-flex justify-content-between align-items-center mb-2 subheader">
                  <h4 class="m-0 subsection-title no-leading-bar">NTRIP Settings for RTK Base</h4>
                </div>
                <div>
                  <div><strong class="content-description">MountPoint:</strong> <span class="mp-value">{{ selectedMountPoint?.stMountPoint }}</span></div>
                  <div><strong class="content-description">NTrip Caster URL:</strong> <span class="mp-value">{{ ntripServer?.url }}</span></div>
                  <div><strong class="content-description">NTrip Caster Port:</strong> <span class="mp-value">{{ ntripServer?.port }}</span></div>
                  <div><strong class="content-description">UserName(Optional):</strong> <span class="mp-value">{{ selectedUser?.uUserName }}</span></div>
                  <div><strong class="content-description">Password:</strong> <span class="mp-value">{{ selectedUser?.uPassword }}</span></div>
                </div>
              </div>

              <!-- NTRIP Settings for RTK Rovers (stacked) -->
              <div class="subsection mt-2 ms-4">
                <div class="d-flex justify-content-between align-items-center mb-2 subheader">
                  <h4 class="m-0 subsection-title no-leading-bar">NTRIP Settings for RTK Rovers</h4>
                </div>
                <div>
                  <div><strong class="content-description">Mount Point:</strong> <span class="mp-value">{{ selectedMountPoint?.stMountPoint }}</span></div>
                  <div><strong class="content-description">NTrip Caster URL:</strong> <span class="mp-value">{{ ntripServer?.url }}</span></div>
                  <div><strong class="content-description">NTrip Caster Port:</strong> <span class="mp-value">{{ ntripServer?.port }}</span></div>
                  <div><strong class="content-description">UserName:</strong> <span class="mp-value">{{ selectedUser?.dUserName }}</span></div>
                  <div><strong class="content-description">Password:</strong> <span class="mp-value">{{ selectedUser?.dPassword }}</span></div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5 d-flex align-items-start">
              <img src="assets/images/landing/GeoAstra_NTRIP.png" alt="GeoAstra NTRIP Diagram" class="img-fluid w-100 rounded border diagram-scale-80 diagram-align-top">
            </div>
          </div>
        </div>

        <!-- Removed separate blocks; these sections are now stacked under the left column of the message box -->
</div>